import { Col, Container, Image, Row } from 'react-bootstrap';
import { motion } from 'motion/react';
import logo1 from "../../assets/b_logo/logo_1.png";
import logo2 from "../../assets/b_logo/logo_2.png";
import logo3 from "../../assets/b_logo/logo_3.png";
import logo4 from "../../assets/b_logo/logo_4.png";

const Company = () => {
  const logos = [logo1, logo2, logo3, logo4]

  const logoVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: (index) => ({
      opacity: 1,
      scale: 1,
      transition: { duration: 0.5, delay: index * 0.1 }
    })
  }

  return (
    <section id="market-logos" className="py-5 bg-light">
      <Container>
        <Row className="g-4 align-items-center justify-content-center text-center">
          {logos.map((logo, index) => (
            <Col xs={6} md={3} key={index}>
              <motion.div
                variants={logoVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                custom={index}
                whileHover={{ scale: 1.1, transition: { duration: 0.3 } }}
              >
                <Image src={logo} fluid className='object-fit-cover' alt="brand" />
              </motion.div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  )
}

export default Company;